import * as z from "zod/v4";

export const getInvoiceCsv = {
  name: "getInvoiceCsv" as const,
  input: z.object({ periodStart: z.date(), periodEnd: z.date().nullish() }),
  output: z.object({ csvUrl: z.string() }),
};
